import React from 'react';

interface CardDashboardTradesDividendsRowProps {
    children: React.ReactNode;
    strong?: boolean;
    large?: boolean;
}

export const CardDashboardTradesDividendsRow: React.FC<CardDashboardTradesDividendsRowProps> = ({
    children,
    strong = false,
    large = false,
}) => (
    <div
        className={
            large
                ? 'text-large leading-large font-black text-text'
                : `flex gap-[1.4rem] text-medium leading-medium${strong ? ' font-black' : ''}`
        }
    >
        {children}
    </div>
);
